/**
 * How much image a session on the person's own computer holds. Every model
 * call goes through cubic's model route on Vercel, which refuses a body over
 * 4.5 MB before the route runs, and OpenCode sends every image the session
 * holds with every call (it drops the oldest only past 25 MiB). So OpenCode
 * shrinks each image it stores, a person's or a tool's, to at most
 * `LOCAL_IMAGE_MAX_BASE64_BYTES` (`media.image` in the laptop config), and the
 * composer keeps the images a session stores under
 * `LOCAL_SESSION_IMAGE_BASE64_BYTES`, about 10 to 15 app screenshots, which
 * leaves the rest of a call's body to the conversation.
 */

/** The base64 bytes OpenCode shrinks each image it stores to (`media.image.max_base64_bytes`). */
export const LOCAL_IMAGE_MAX_BASE64_BYTES = 300_000;

/** The base64 bytes of images one session may store before its composer takes no more. */
export const LOCAL_SESSION_IMAGE_BASE64_BYTES = 2_500_000;

/**
 * The most a new image of `size` bytes takes of its session's room once stored, since OpenCode
 * may store it smaller.
 */
export function localImageBase64Bytes(size: number): number {
  return Math.min(4 * Math.ceil(size / 3), LOCAL_IMAGE_MAX_BASE64_BYTES);
}
